import FirstStep from './processSteps/FirstStep/FirstStep';
import SecondStep from './processSteps/SecondStep/SecondStep';
import ThirdStep from './processSteps/ThirdStep/ThirdStep';

// Steps
export const viewStepsForIssuanceUC = [
    {
        id: '1',
        content: (manageSubStepChange: () => void, goToNextSection: () => void) => <FirstStep manageSubStepChange={manageSubStepChange} />
    },
    // This step is not removed just in case it comes in handy again in the future.
    // Right now it is being emulated in step 1
    // {
    //   id: "2",
    //   content: (manageSubStepChange: () => void, goToNextSection: () => void) => (
    //     <SecondStep manageSubStepChange={manageSubStepChange} />
    //   ),
    // },
    {
        id: '2',
        content: (manageSubStepChange: () => void, goToNextSection: () => void) => <ThirdStep manageSubStepChange={manageSubStepChange} goToNextSection={goToNextSection} />
    }
];

export const viewStepsForVerificationUC = [
    {
        id: '1',
        content: (manageSubStepChange: () => void, goToNextSection: () => void) => <FirstStep manageSubStepChange={manageSubStepChange} />
    }
    // This step is not removed just in case it comes in handy again in the future.
    // Right now it is being emulated in step 1
    // {
    //   id: "2",
    //   content: (manageSubStepChange: () => void, goToNextSection: () => void) => (
    //     <SecondStep manageSubStepChange={manageSubStepChange} />
    //   ),
    // },
];
